import React, { Component } from 'react';
import { ReactComponent as EmptyIcon } from '../icons/download_empty.svg';
import { translate } from '../translations';
import { getTheme } from '../Theme';

import wwwImg from '../images/media_web.png';
import radioImg from '../images/media_radio.png';
import tvImg from '../images/media_tv.png';
import paperImg from '../images/media_paper.png';
import tempImg from '../images/contact_navImg.png';

const media = [
  {
    name: 'Internet',
    img: wwwImg,
    links: [
      {
        href:
          'https://forumakademickie.pl/news/nowy-silnik-z-politechniki-lubelskiej/#comment-937',
        description:
          '"Nowy silnik z Politechniki Lubelskiej" - Forum Akademickie, 24.01.2019 r.'
      },
      {
        href: 'https://www.lublin112.pl/tag/przemyslaw-filipek/',
        description:
          '"Może pracować pod wodą i w kosmosie. Lubelscy naukowcy stworzyli prototyp nowego silnika (zdjęcia)" - Wiadomości z Lublina i regionu, 25.01.2019 r.'
      },
      {
        href:
          'http://www.geekweek.pl/news/2019-01-26/politechnika-lubelska-z-przelomowym-supernowoczesnym-silnikiem-elektrycznym/',
        description:
          '"Na Politechnice Lubelskiej powstał supernowoczesny silnik elektryczny" - Geek Week, 26.01.2019 r.'
      },
      {
        href: 'https://www.pollub.pl/pl/news/get/id/8162',
        description:
          '"Zamień stary silnik na nowy. Naukowcy proponują swój wynalazek" - Politechnika Lubelska, 24.01.2019 r.'
      },
      {
        href:
          'https://polskiprzemysl.com.pl/wiadomosci/bezszczotkowy-silnik-pradu-stalego/',
        description:
          '"Inżynierowie z Politechniki Lubelskiej zbudowali prototyp bezrdzeniowego, bezszczotkowego silnika prądu stałego" - Portal przemysłowy Polski Przemysł, 29.01.2019 r.'
      },
      {
        href:
          'https://www.startupmag.pl/artykuy/2019/1/28/przelomowy-silnik-pradu-stalego-clbldc',
        description:
          '"Profesor ze studentami z Politechniki Lubelskiej opracowali przełomowy silnik prądu stałego CLBLDC" - StartUp Magazine 24, 28.01.2019 r.'
      },
      {
        href: 'https://www.toopics.com/p/1963879771923633177_6887722981',
        description: 'Politechnika Lubelska 24.01.2019 r.'
      },
      {
        href: 'https://v-nocdn.iplsc.com/-/0007W6PWEYOIJ8J1-V1.mp4',
        description: 'Film z prezentacji silnika LMB, 24.01.2019 r.'
      }
    ]
  },
  {
    name: 'Radio',
    img: radioImg,
    links: [
      {
        href:
          'https://www.rmf24.pl/nauka/news-na-politechnice-lubelskiej-powstal-supernowoczesny-silnik-el,nId,2801669',
        description:
          '"Na Politechnice Lubelskiej powstał supernowoczesny silnik elektryczny" - Radio RMF 24, 25.01.2019 r.'
      },
      {
        href:
          'https://radio.lublin.pl/news/lubelski-silnik-moze-pracowac-pod-woda-i-w-kosmosie',
        description:
          ' "Lubelski silnik może pracować pod wodą i w kosmosie" - Radio Lublin, 24.01.2019 r.'
      },
      {
        href:
          'http://lublin.eska.pl/newsy/naukowcy-spotkali-sie-z-przedsiebiorcami-bylismy-na-innovation-open-day-na-politechnice-lubelskiej-galeria-audio/14430/5',
        description:
          ' "Innovation Open Day na Politechnice Lubelskiej, 30.01.2019 r.'
      }
    ]
  },
  {
    name: 'Telewizja',
    img: tvImg,
    links: [
      {
        href: 'https://lublin.tvp.pl/40998827/24-stycznia-2019-g-1230',
        description: 'Panorama Lubelska - TVP3 Lublin, 25.01.2019 r.'
      }
    ]
  },
  {
    name: 'Prasa',
    img: paperImg,
    links: [
      {
        href:
          'https://kurierlubelski.pl/nowy-silnik-elektryczny-z-politechniki-lubelskiej-jest-mniejszy-lzejszy-i-wydajniejszy-zdjecia/ar/13833596',
        description:
          'Nowy silnik elektryczny z Politechniki Lubelskiej jest mniejszy, lżejszy i wydajniejszy (ZDJĘCIA)" - Kurier Lubelski, 24.01.2019 r.'
      }
    ]
  }
];

// const Type = (props) => {
//   const { media } = props;
//   return (
//     <>
//       <div className='circleImg'>
//         <img src={media.img} alt={'media'} />
//       </div>

//       <div className='media-header'>
//         <h2>{translate(media.name)}</h2>
//       </div>
//       <ol>
//         {media.links.map((h, i) => (
//           <Links hrefs={h} key={i} />
//         ))}
//       </ol>
//     </>
//   );
// };

const Media = () => {
  return (
    <section id="media">
      <img className={getTheme('template-img')} src={tempImg} alt={'test'} />
      <div className="container">
          <div className={getTheme('download-container')}>
            <EmptyIcon className={getTheme('downloads-svg')} />
            <h2> {translate('Chwilowo - brak')}</h2>
          </div>
          {/* <div className='media-container'>
            {media.map((m) => (
              <Type media={m} key={m} />
            ))}
          </div> */}
      </div>
    </section>
  );
};

export default Media;
